import { Skeleton } from 'antd';
import { useAtom } from 'jotai';
import React from 'react';
import { appAccountsDetailsAtom, videoAccountsDetailsAtom, apiAccountsDetailsAtom } from '../atoms';
import AccountList from './AccountList/AccountList';
import { StyledH4 } from './styled';

const AccountView = ({ isCustomerListFetching }) => {
  const [videoAccountDetails, setVideoAccountsDetails]: any = useAtom(videoAccountsDetailsAtom);
  const [appAccountDetails, setAppAccountDetails]: any = useAtom(appAccountsDetailsAtom);
  const [apiAccountsDetails, setApiAccountDetails]: any = useAtom(apiAccountsDetailsAtom);

  if (isCustomerListFetching) {
    return <Skeleton paragraph={{ rows: 20 }} active></Skeleton>;
  }
  return (
    <div style={{ textAlign: 'left', minHeight: '100%', maxHeight: '100%', overflowY: 'auto' }}>
      <StyledH4>Select Accounts To View</StyledH4>
      <hr style={{ margin: 0, padding: 0 }} />
      {videoAccountDetails.length ? (
        <AccountList
          accountDetails={videoAccountDetails}
          setAccountDetails={setVideoAccountsDetails}
          label={'Video Accounts'}
        />
      ) : (
        ''
      )}
      <hr />
      {appAccountDetails.length ? (
        <AccountList
          accountDetails={appAccountDetails}
          setAccountDetails={setAppAccountDetails}
          label={'Eco Accounts'}
        />
      ) : (
        ''
      )}
      {apiAccountsDetails.length ? (
        <AccountList
          accountDetails={apiAccountsDetails}
          setAccountDetails={setApiAccountDetails}
          label={'API Accounts'}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default AccountView;
